import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

import { PageHeaderSchema } from './schema';
import { useSelector } from 'react-redux';

const PageHeaderData = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  // const schema = PageHeaderSchema({ ...props, intl });
  // const dataAdapter = blocksConfig.pageheader.dataAdapter;

  const schema = blocksConfig[data['@type']].blockSchema({
    ...props,
    intl,
  });
  const dataAdapter = blocksConfig[data['@type']].dataAdapter;

  const request = useSelector((state) => state.content.subrequests[block]);
  const content = request?.data;

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value, item) => {
        dataAdapter({
          block,
          data,
          id,
          onChangeBlock,
          value,
          content,
          item,
        });
      }}
      formData={data}
      block={block}
      onChangeBlock={onChangeBlock}
      blocksConfig={blocksConfig}
    />
  );
};

export default PageHeaderData;
